import * as React from "react";
import ImageView from "../../../components/SmartImage";
import { CardBannerContainer } from "./styles";
import { formatBannerGridSize } from "../../../utils/banner";
import { isNotBlankArray } from "../../../utils/array";
const ANIMATION_DURATION = 1000;
class CardBanner extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            cIndex: 2,
            animationDuration: 0,
        };
        this.autoSwipe = true;
        this.canClick = true;
        this.countDown = 0;
        this.getStyle = () => {
            const bannerWidth = 435;
            const { cIndex, animationDuration } = this.state;
            const style = {};
            const wrapperOffsetLeft = -bannerWidth * cIndex;
            style.width = `${this.getNodeCount}00%`;
            style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
            style.transitionDuration = `${animationDuration}ms`;
            style.WebkitTransform = style.transform;
            style.transitionTimingFunction = "ease-out";
            return style;
        };
        this.onClick = (e, link) => {
            e.preventDefault();
            if (link === null || link === void 0 ? void 0 : link.trim()) {
                open(link, "_blank");
            }
        };
        this.onNext = () => {
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.setState(state => ({
                cIndex: state.cIndex + 1,
                animationDuration: ANIMATION_DURATION,
            }));
        };
        this.onBack = () => {
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.setState(state => ({
                cIndex: state.cIndex - 1,
                animationDuration: ANIMATION_DURATION,
            }));
        };
        this.onTransitionEnd = () => {
            if (this.state.cIndex > this.props.cardBanners.length) {
                this.setState({
                    cIndex: 1,
                    animationDuration: 0,
                });
            }
            if (!this.state.cIndex) {
                this.setState({
                    cIndex: this.props.cardBanners.length,
                    animationDuration: 0,
                });
            }
            this.canClick = true;
        };
        this.renderCardBanner = (img, link, index) => {
            const { placeholderBg } = this.props;
            return (React.createElement("li", { key: index },
                React.createElement("a", { "data-href": link, href: link, onClick: (e) => this.onClick(e, link) },
                    React.createElement(ImageView, { src: img, aliSize: 4.2, qnParams: { w: 420 }, isLazyLoad: false, online: this.props.online, placeholder: placeholderBg, fallbackSrc: placeholderBg }))));
        };
    }
    componentDidMount() {
        this.autoScroll();
    }
    componentWillUnmount() {
        this.stopAutoScroll();
    }
    autoScroll() {
        clearTimeout(this.countDown);
        this.countDown = setTimeout(() => {
            if (this.autoSwipe && document.visibilityState === "visible") {
                this.onNext();
            }
            this.autoScroll();
        }, 4000);
    }
    stopAutoScroll() {
        clearTimeout(this.countDown);
    }
    getNodeCount() {
        const { cardBanners } = this.props;
        return cardBanners.length + 4;
    }
    render() {
        const { cardBanners, positionId, style = {}, minWidth = 0, width = "0" } = this.props;
        if (!isNotBlankArray(cardBanners)) {
            return null;
        }
        const banner = cardBanners[0];
        const { width: gridWidth, aspectRatio } = formatBannerGridSize(banner, Math.max(+width, minWidth));
        return (React.createElement(CardBannerContainer, { id: positionId, onMouseEnter: () => (this.autoSwipe = false), onMouseLeave: () => (this.autoSwipe = true), gridWidth: +gridWidth, gridHeight: banner.width ? aspectRatio * 420 : 0, style: Object.assign({}, style) },
            React.createElement("div", { className: "leftArrow", onClick: this.onBack }),
            React.createElement("ul", { className: "scrollContainer", style: this.getStyle(), onTransitionEnd: this.onTransitionEnd },
                cardBanners
                    .slice(-2)
                    .map((item, index) => this.renderCardBanner(item.img, item.link, index)),
                cardBanners.map((item, index) => this.renderCardBanner(item.img, item.link, index)),
                cardBanners
                    .slice(0, 2)
                    .map((item, index) => this.renderCardBanner(item.img, item.link, index))),
            React.createElement("div", { className: "rightArrow", onClick: this.onNext })));
    }
}
export default CardBanner;
